import { useApp } from '../../contexts/AppContext';
import { formatAmount } from '../../constants';

export default function ByEntityTab() {
  const { filteredExceptions: allExceptions, loading } = useApp();

  if (loading) return <div style={{ textAlign: 'center', padding: 80, color: 'var(--text-secondary)' }}>Loading...</div>;

  const ENTITY_NAMES: Record<string, string> = {
    '1000': 'KSA (SAR)', '2000': 'USA (USD)', '3000': 'Brazil (BRL)',
  };

  // Group by entity (jurisdiction field)
  const byEntity: Record<string, { total: number; flagged: number; escalated: number; resolved: number; exposure: number }> = {};
  for (const exc of allExceptions) {
    const entity = exc.jurisdiction || exc.entity_code || 'Unknown';
    if (!byEntity[entity]) byEntity[entity] = { total: 0, flagged: 0, escalated: 0, resolved: 0, exposure: 0 };
    byEntity[entity].total++;
    const st = (exc.status || '').toLowerCase();
    if (st === 'flagged') byEntity[entity].flagged++;
    if (st === 'escalated') byEntity[entity].escalated++;
    if (st.startsWith('resolved')) byEntity[entity].resolved++;
    byEntity[entity].exposure += exc.amount || 0;
  }

  const sorted = Object.entries(byEntity).sort((a, b) => b[1].exposure - a[1].exposure);

  return (
    <div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: 14 }}>
        {sorted.map(([entity, data]) => {
          const label = ENTITY_NAMES[entity] || `Entity ${entity}`;
          const resolvedPct = data.total > 0 ? Math.round((data.resolved / data.total) * 100) : 0;
          return (
            <div key={entity} className="card" style={{ padding: '18px 20px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 12 }}>
                <div>
                  <div style={{ fontSize: 14, fontWeight: 700 }}>{label}</div>
                  <div style={{ fontSize: 11, color: 'var(--text-secondary)' }}>{data.total} exceptions</div>
                </div>
                <div className="mono" style={{ fontSize: 16, fontWeight: 700, color: 'var(--amber)' }}>
                  {formatAmount(data.exposure)}
                </div>
              </div>
              <div style={{ height: 5, background: 'var(--bg-elevated)', borderRadius: 3, overflow: 'hidden', marginBottom: 10 }}>
                <div style={{ height: '100%', width: `${resolvedPct}%`, background: 'var(--green)', borderRadius: 3 }} />
              </div>
              <div style={{ display: 'flex', gap: 16, fontSize: 10, color: 'var(--text-tertiary)' }}>
                <span><span style={{ color: 'var(--amber)', fontWeight: 700 }}>{data.flagged}</span> flagged</span>
                <span><span style={{ color: 'var(--red)', fontWeight: 700 }}>{data.escalated}</span> escalated</span>
                <span><span style={{ color: 'var(--green)', fontWeight: 700 }}>{data.resolved}</span> resolved</span>
                <span style={{ marginLeft: 'auto' }}>{resolvedPct}% resolved</span>
              </div>
            </div>
          );
        })}
        {sorted.length === 0 && (
          <div className="card" style={{ padding: 48, textAlign: 'center', color: 'var(--text-secondary)', gridColumn: '1 / -1' }}>
            No entity data available
          </div>
        )}
      </div>
    </div>
  );
}
